import React, { useMemo, useContext } from 'react';
import { useChannelStateContext, useChatContext } from 'stream-chat-react';
import { Text, theme, Icon, Button, ChannelThumbnail } from 'components';
import styled from 'styled-components';
import { ContextualChatContext } from 'contexts';
import {
  getOtherParticipantsFullNames,
  getOtherParticipantsFirstNames,
} from 'utils';
import { useBreakpoint } from 'hooks';
import { Color } from '@bb/elements-web';

const CustomChannelHeader = () => {
  const { md, lg } = useBreakpoint();
  const { channel } = useChannelStateContext();
  const {
    client: { userID },
  } = useChatContext();
  const { setViewDetailsPanel, viewDetailsPanel, setChannel } = useContext(
    ContextualChatContext,
  );
  const { name } = channel.data || {};

  const channelMembers = useMemo(
    () => getOtherParticipantsFullNames(channel, userID),
    [channel, userID],
  );

  const channelMembersFirstNames = useMemo(
    () =>
      getOtherParticipantsFirstNames(channel.state.members, userID, true, true),
    [channel.state.members, userID],
  );

  return (
    <StyledContainer>
      <StyledChannelItemContainer>
        {((!lg && viewDetailsPanel) || !md) && (
          <Icon
            type="antdArrowLeftOutlined"
            width={18}
            color="primary"
            onClick={() => {
              setViewDetailsPanel(false);

              if (!md) {
                setChannel(null);
              }
            }}
          />
        )}
        <StyledMinAvatar>
          <ChannelThumbnail channel={channel} />
        </StyledMinAvatar>
        <StyledChatDetails>
          <StyledChannelName ellipsis>
            {name ?? channelMembers}
          </StyledChannelName>
          <StyledChannelMembers ellipsis>
            {channelMembersFirstNames.concat(', You')}
          </StyledChannelMembers>
        </StyledChatDetails>
        {viewDetailsPanel ? (
          <StyledListingDetailsButtonClose
            onClick={() => {
              setViewDetailsPanel(false);
            }}
            type="default"
            shape="round"
            size="middle"
          >
            <Icon
              type="antdDoubleRightOutlined"
              width={theme.iconSize}
              color="primary"
            />
          </StyledListingDetailsButtonClose>
        ) : (
          <StyledListingDetailsButton
            onClick={() => {
              setViewDetailsPanel(true);
            }}
            type="default"
            shape="round"
            size="middle"
            color={Color.PRIMARY}
          >
            <Icon
              type="antdDoubleLeftOutlined"
              width={theme.iconSize}
              color="primary"
            />
            Details
          </StyledListingDetailsButton>
        )}
      </StyledChannelItemContainer>
    </StyledContainer>
  );
};

const StyledMinAvatar = styled.div`
  min-width: 50px;
`;

const StyledContainer = styled.div`
  padding: 10px;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 12px;
`;

const StyledChannelItemContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  background-color: '#FFFFFF';
`;

const StyledChatDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1 auto;
  min-width: 0;
`;

const StyledChannelName = styled(Text)`
  font-weight: 700;
  margin: 0;
  font-size: 15px;
`;

const StyledChannelMembers = styled(Text)`
  margin: 0;
  font-size: 12px;
`;
const StyledListingDetailsButton = styled(Button)`
  position: relative;
  display: flex;
  align-items: center;
  gap: 6px;
  color: ${Color.PRIMARY};
  padding: 4px 8px;
  margin-left: auto;
`;

const StyledListingDetailsButtonClose = styled(Button)`
  position: relative;
  display: flex;
  align-items: center;
  padding: 4px 8px;
  color: ${Color.PRIMARY};
  margin-left: auto;
`;

export default CustomChannelHeader;
